import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';

/**
 * 메인 배너 컴포넌트
 * @returns JSX.Element
 */
const MainBanner = () => {
	return (
		<section className="main-banner main-section">
			<div className="main-banner-inner">
				<div className="title-group">
					<span>
						<p className="sub">국내 최초 스타트업 성장 지원 종합플랫폼</p>
						<figure className="logo-text">
							<figcaption>STELLA</figcaption>
						</figure>
						<p className="desc">
							인력이 부족한 스타트업을 위해 스텔라를 기반으로 하는 Virtual CFO 및 통합경영지원 서비스를 제공하여 <br />
							기업의 경영의사결정을 돕고, 효율적인 자원 관리를 지원합니다. <br />
							스텔라는 개방형 재무정보 플랫폼으로, <br />
							스타트업의 생태계를 지원하는 다양한 회계, 세무, 법률, 특허 분야의 전문가, 투자자, IT 서비스 기업이 함께
							합니다. <br />
							특히, 스텔라 이용고객은 국내 최대 회계법인인 삼일회계법인으로부터 스텔라를 기반으로 하는 <br />
							통합경영지원서비스를 제공 받을 수 있습니다. <br />
							<span>스타트업과 성장기업의 모든 고민을 스텔라를 통해 해결할 수 있습니다.</span>
						</p>
					</span>
					<div className="logo-symbol"></div>
				</div>
				<Link to={NAV_PATH.INTRO} className="text-link">
					자세히보기
				</Link>
			</div>
		</section>
	);
};
export default MainBanner;
